export enum TransferTypeEnum {
  TICKET = 'TICKET',
  PASS = 'PASS'
}
